export default "__VITE_ASSET__a4021ada__"